import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import translations from './translations.json'

export const defaultNS = 'translations'
export const resources = {
  en: {
    translations,
  },
}

i18n.use(initReactI18next).init({
  lng: 'en',
  defaultNS,
  resources,
  returnNull: false,
})
